module.exports = __webpack_public_path__ + "static/media/tequila.00f2a552.svg";